import React from 'react';
import styles from '../css/components/formcard.module.css';

export default function FormCard({ children, className = '', compact = false }) {
  return (
    <div className={`${styles.card} ${compact ? styles.compact : ''} ${className}`.trim()}>
      {children}
    </div>
  );
}
